import { getEmptyProduct } from '@/utils/emptyProduct';
import mockConfig from '@/mocks/mockConfig';
import useConfigStore from '@/store/config.store';
import { loadFonts } from '@/utils/loadFonts';
import EUserName from '@/typescript/enums/EUserName';
import useProductStore from '@/store/product.store';
import { getProducts } from '@/api/product.api';
import Events from '@/services/Events';
import i18n, { t } from '@/translations/i18n';
import { EAppStep } from '@/typescript/enums/EAppStep';
import { initProductImages } from '@/utils/productImage';
import { getUserConfigurations } from '@/api/userConfiguration.api';
import iFrameApi from '@/api';
import { createUniqueId } from '@/utils/createUniqueId';
import ObsidianApi from 'obsidian-api';
import type { IAppConfig } from '@/typescript/interfaces/IAppConfig';

export default async function initStore() {
    const configStore = useConfigStore();

    let config = ObsidianApi.$getConfig() as IAppConfig;
    if (Object.keys(config).length === 0) {
        config = mockConfig();
    }

    configStore.isMobile = config.is_mobile;
    configStore.isAdmin = !!config.is_admin;

    configStore.token = config.token;
    configStore.userName = configStore.isAdmin ? EUserName.ADMIN : EUserName.USER;
    configStore.prestashopUserId = config.prestashop_user_id;
    configStore.showAspectSelector = !!config.show_aspect_selector;

    configStore.lang = config.lang;
    i18n.global.locale = configStore.lang;
    configStore.fonts = loadFonts();
    configStore.uniqueId = createUniqueId();

    const productStore = useProductStore();
    try {
        productStore.productList = [...productStore.productList, ...(await getProducts())];
    } catch (e) {
        Events.emit('call-toaster', { title: t('error_title'), body: t('fetch_template_error'), type: 'error' });
    }

    if (configStore.prestashopUserId) {
        try {
            productStore.productList = [...productStore.productList, ...(await getUserConfigurations(configStore.prestashopUserId))];
        } catch (e) {
            Events.emit('call-toaster', { title: t('error_title'), body: t('fetch_template_error'), type: 'error' });
        }
    }

    if (config.template_id) {
        const selectedProduct = productStore.productList.find((product) => product.id === config.template_id) || getEmptyProduct();
        productStore.selectedProduct = await initProductImages(selectedProduct);
        configStore.currentStep = EAppStep.EDITION;
    }
    iFrameApi.sendEvent('onAppLoaded');
}
